import { Deeplinks } from './deeplinks';

export class DeeplinksFactory {

    public initialize(): void {
        document.querySelectorAll('a[data-deeplink="true"]').forEach((element: HTMLAnchorElement) => {
            new Deeplinks(element);
        });
    }

}
